import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
})
export class ConfirmationDialogComponent implements OnInit {
  message: string;
  title: string;
  isConfirmation: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.isConfirmation = data && data.isConfirmation !== undefined ? data.isConfirmation : this.isConfirmation;
    this.title = data && data.title !== undefined ? data.title : 'Oops!';
    this.message = data && data.message !== undefined ? data.message : "Are you sure you want to Delete?";

  }

  ngOnInit() {}
}
